import { render } from "./AnnualProfitChart.vue?vue&type=template&id=2639bd19&ts=true"
import script from "./AnnualProfitChart.vue?vue&type=script&lang=ts"
export * from "./AnnualProfitChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__